import { Mail, MapPin, Github, Twitter, Linkedin, FileText, Shield, Cookie, Scale, Settings2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { openCookieSettings } from "@/components/cookies/CookieConsent";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <>
      <footer className="ed-section-dark border-t border-ed-on-dark/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          {/* Top rule */}
          <div className="w-full h-px bg-ed-on-dark/8 mb-12" />

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16">
            {/* Brand column */}
            <div className="md:col-span-4 space-y-6">
              <div className="space-y-2">
                <h3 className="font-display text-2xl font-bold tracking-tight text-ed-on-dark">
                  KLIKAN
                </h3>
                <p className="font-display text-[0.65rem] tracking-[0.28em] uppercase text-ed-on-dark/40">
                  Civic Tech
                </p>
              </div>
              <div className="text-ed-on-dark/60 text-sm leading-relaxed font-body max-w-xs">
                <p>{t('footer.about.desc')}</p>
              </div>

              <div className="pt-2">
                <div className="flex items-center gap-3 text-ed-on-dark/50 text-sm font-body">
                  <MapPin className="h-4 w-4 text-ed-on-dark/30" />
                  <span>France</span>
                </div>
                <a
                  href="mailto:contact@klikan.fr"
                  className="flex items-center gap-3 text-ed-on-dark/50 text-sm font-body mt-2 hover:text-ed-on-dark/80 transition-colors duration-300"
                >
                  <Mail className="h-4 w-4 text-ed-on-dark/30" />
                  <span>contact@klikan.fr</span>
                </a>
              </div>
            </div>

            {/* Navigation column */}
            <div className="md:col-span-2 space-y-5">
              <p className="font-display text-[0.65rem] tracking-[0.28em] uppercase text-ed-on-dark/40">
                {t('footer.quickLinks')}
              </p>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/"
                    className="text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                  >
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#comment-ca-marche"
                    className="text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                  >
                    {t('footer.howItWorks')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#faq"
                    className="text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/commitments"
                    className="text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                  >
                    {t('footer.commitments')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#communaute"
                    className="text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                  >
                    Communauté
                  </Link>
                </li>
              </ul>
            </div>


          {/* Legal column */}
          <div className="md:col-span-3 space-y-5">
            <p className="font-display text-[0.65rem] tracking-[0.28em] uppercase text-ed-on-dark/40">
              {t('footer.legal')}
            </p>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/legal"
                  className="flex items-center gap-2 text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300"
                >
                  <FileText className="h-3.5 w-3.5 text-ed-on-dark/30" />
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="flex items-center gap-2 text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300"
                >
                  <Shield className="h-3.5 w-3.5 text-ed-on-dark/30" />
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="flex items-center gap-2 text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300"
                >
                  <Cookie className="h-3.5 w-3.5 text-ed-on-dark/30" />
                  {t('footer.cookies')}
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="flex items-center gap-2 text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300"
                >
                  <Scale className="h-3.5 w-3.5 text-ed-on-dark/30" />
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  aria-haspopup="dialog"
                  className="flex items-center gap-2 text-ed-on-dark/60 text-sm font-body hover:text-ed-on-dark transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ed-on-dark/40 rounded-sm"
                >
                  <Settings2 className="h-3.5 w-3.5 text-ed-on-dark/30" aria-hidden="true" />
                  Gérer les cookies
                </button>
              </li>
            </ul>
          </div>

          {/* Social column */}
          <div className="md:col-span-3 space-y-5">
            <p className="font-display text-[0.65rem] tracking-[0.28em] uppercase text-ed-on-dark/40">
              {t('footer.followUs')}
            </p>
            <div className="flex gap-3">
              <a
                href="https://twitter.com/klikan_app"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-ed-on-dark/10 flex items-center justify-center text-ed-on-dark/50 hover:text-ed-on-dark hover:border-ed-on-dark/30 transition-all duration-300"
                aria-label="Twitter"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a
                href="https://linkedin.com/company/klikan"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-ed-on-dark/10 flex items-center justify-center text-ed-on-dark/50 hover:text-ed-on-dark hover:border-ed-on-dark/30 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://github.com/klikan"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-ed-on-dark/10 flex items-center justify-center text-ed-on-dark/50 hover:text-ed-on-dark hover:border-ed-on-dark/30 transition-all duration-300"
                aria-label="GitHub"
              >
                <Github className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-ed-on-dark/8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-ed-on-dark/35 text-xs font-body">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/legal"
                className="text-ed-on-dark/35 text-xs font-body hover:text-ed-on-dark/70 transition-colors duration-300"
              >
                Mentions légales
              </Link>
              <Link
                to="/privacy"
                className="text-ed-on-dark/35 text-xs font-body hover:text-ed-on-dark/70 transition-colors duration-300"
              >
                Confidentialité
              </Link>
              <Link
                to="/cookies"
                className="text-ed-on-dark/35 text-xs font-body hover:text-ed-on-dark/70 transition-colors duration-300"
              >
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </>
);
};

export default Footer;
